import { FormattedMessage } from "react-intl";

import { RanaButton, RanaModal } from "@nens/ranalib";

import { SchematisationsOverview } from "@/lib/catalogue/features/schematisations/schematisations-overview";
import type { AddToProjectButtonOverride } from "@/lib/catalogue/features/schematisations/types/add-to-project-button-override";
import { cancelButtonText } from "@/translations";

import { useSubmitModelSchemaCatalogue } from "../hooks/use-submit-model-schema-catalogue";

interface ModelSchemaUpdateInCatalogueProps {
  fileId: string;
  isOpen: boolean;
  onClose: () => void;
  onCloseAll: () => void;
}

export function ModelSchemaUpdateInCatalogue({
  fileId,
  isOpen,
  onClose,
  onCloseAll,
}: ModelSchemaUpdateInCatalogueProps) {
  const { submitToCatalogue, isMutating } = useSubmitModelSchemaCatalogue({
    fileId,
    onCloseAll,
  });

  const renderUpdateButton: AddToProjectButtonOverride = ({ schematisation }) => (
    <RanaButton
      isLoading={isMutating}
      onClick={() => submitToCatalogue({ schematisationId: schematisation.id })}
      variant="primary"
    >
      <FormattedMessage
        id="projectfile.update_existing_model_schema"
        defaultMessage="Update this model schematisation"
      />
    </RanaButton>
  );

  return (
    <RanaModal
      isOpen={isOpen}
      onClose={onClose}
      w="full"
      h="full"
      topBar={
        <FormattedMessage
          id="projectfile.update_existing_model_schema"
          defaultMessage="Update an existing model schema"
        />
      }
      buttons={[
        {
          children: cancelButtonText,
          variant: "tertiary",
          isDisabled: isMutating,
          onClick: onClose,
        },
      ]}
    >
      <SchematisationsOverview
        overwriteAddToProjectButton={renderUpdateButton}
        disableSettingSearchParams
      />
    </RanaModal>
  );
}
